module.exports = __webpack_public_path__ + "img/cp-mp-r2-1.3eb29e41.jpg";